import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $ModalModuleName } from "./modal.types";

export const get = () => (state: IState) => {
    return getValueState(state, $ModalModuleName) ?? [];
};
